import { render, staticRenderFns } from "./DocumentTemplateList.vue?vue&type=template&id=44b152bd&scoped=true"
import script from "./DocumentTemplateList.vue?vue&type=script&lang=js"
export * from "./DocumentTemplateList.vue?vue&type=script&lang=js"
import style0 from "./DocumentTemplateList.vue?vue&type=style&index=0&id=44b152bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b152bd",
  null
  
)

export default component.exports